import { API_DEV } from "constants/api";
import { handleAPIResult, header } from "utils";

export const sessionService = {
  destroy,
};

function destroy() {
  const getInfo = {
    method: "DELETE",
    headers: header(API_DEV),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/logout", getInfo)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
